import { children, JSXElement } from "solid-js"
import styles from './st-alert.module.css';
import Flexbox from '../st-flexbox/st-flexbox';

export type AlertType = 'default' | 'primary' | 'success' | 'info' | 'danger' | 'warning' | 'highlight';

export class STAlertParams {
    children: JSXElement;
    type!: AlertType;
}

export default function STAlert(params: STAlertParams) {
    const content = children(() => params.children)

    return <Flexbox dir="horizontal" middle class={styles.alert} data-type={params.type}>
        <i style="font-size: 1.4em; margin-right: 10px" class="fas fa-info-circle"></i>
        <div>
            {content()}
        </div>
    </Flexbox>
}
STAlert.defaultProps = new STAlertParams();